import { Component, h, Prop, State, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-header',
  styleUrls: ['dda-header-main.css'],
  shadow: false,
})
export class DdaHeader {
  @Prop() firstLogoHref: string = '#';
  @Prop() firstLogoSrc: string;
  @Prop() firstLogoWhiteSrc: string;
  @Prop() firstLogoAlt: string;

  @Prop() secondLogoHref: string = '#';
  @Prop() secondLogoSrc: string;
  @Prop() secondLogoWhiteSrc: string;
  @Prop() secondLogoAlt: string;

  @Prop() sideMainMenuTitle: string;
  @Prop() sideOtherMenuTitle: string;

  @Prop() header_submenu_type: 'mega_menu' | 'normal_sub_menu';
  @Prop() sideMenuItems: string;
  @Prop() header_default_submenu: boolean = false;
  @Prop() read_speaker_link: string;
  @Prop() searchText: string;
  @Prop() loginLink: string;
  @Prop() loginIcon: string;
  @Prop() loginText: string = null;
  @Prop() language_text: string;
  @Prop() language_tooltip: string;
  @Prop() login_tooltip: string;
  @Prop() accessibility_tooltip: string;
  @Prop() search_tooltip: string;
  @Event() languageSwitch: EventEmitter<void>;
  @Event() loginClick: EventEmitter<void>;
  @Event() navigatorClick?: EventEmitter<string>;
  @Event() smTextSize: EventEmitter<void>;
  @Event() baseTextSize: EventEmitter<void>;
  @Event() lgTextSize: EventEmitter<void>;
  @Event() normalContrast: EventEmitter<void>;
  @Event() blindContrast: EventEmitter<void>;
  @Event() redContrast: EventEmitter<void>;
  @Event() greenContrast: EventEmitter<void>;
  @State() isMenuOpen: boolean = false;
  @State() isSubMenuOpen: boolean = false;
  @State() isSideSubMenuOpen: boolean = false;
  @State() isAccessibiltyOpen: boolean = false;
  @State() isMobileAccessibiltyOpen: boolean = false;
  @Prop() hamburger_menu_button_name: string;
  @Prop() accessibility_button_text: string;
  @Prop() accessibility_button_id: string;
  @Prop() accessibility_button_icon_family: string;
  @Prop() accessibility_button_icon_name: string;
  @Prop() search_button_name: string;
  @Prop() search_input_name: string;
  @Prop() search_value: string;
  @Prop() language_button_name: string;
  @Prop() close_menu_button_name: string;
  @Prop() close_accessibility_button_name: string;
  @Prop() toggle_accessibility_button_name: string;

  @State() openMenus: { [index: string]: boolean } = {};

  @Prop() usePredesignedAccessibilityMenu: boolean = true;
  @Prop() useNavigator: 'true' | 'false' = 'false';
  @Event() accessibilitymenufunctionality: EventEmitter<void>;
  @Event() searchfunctionality: EventEmitter<string>;

  @Prop() search_input_placeholder: string;

  @Prop() mobileMenuSearchId: string = 'mobileSearch';
  @Prop() mobileMenuSearchUrl: string = 'javascript:void(0)';

  @Prop() contrast_title: string;
  @Prop() contrast_description: string;
  @Prop() contrast_noraml_text: string;
  @Prop() contrast_color_blind_text: string;
  @Prop() contrast_red_weakness_text: string;
  @Prop() contrast_green_weakness_text: string;
  @Prop() selected_contrast: 'normal' | 'colorblind' | 'redweakness' | 'greenweakness' = 'normal';
  @Prop() selected_text_size: 'normal' | 'large' | 'small';
  @Prop() screen_reader_title: string;
  @Prop() screen_reader_description: string;
  @Prop() text_size_title: string;
  @Prop() text_size_description: string;
  @Prop() hideOtherMenu: boolean = false;
  @Prop() otherMenuItems: string;
  @State() parsedOtherMenuItems: { label: string; href: string }[] = [];
  @State() parsedDropDownMenuItems: { label: string; href: string }[] = [];

  @Prop() quickLinks: string | any[];
  @Prop() showQuickLinksIcon?: boolean = true;

  @Prop() useLoginPopup: boolean = false;
  @Prop() loginPopupLinks:
    | string
    | Array<{
        popupItemLabel: string;
        url: string;
      }> = [];
  @State() isDesktopLoginPopupOpen: boolean = false;
  @State() isMobileLoginPopupOpen: boolean = false;

  private lastScrollTop = 0;

  componentWillLoad() {
    this.parseOtherMenuItems(this.otherMenuItems);
  }

  parseOtherMenuItems(newValue: string) {
    try {
      this.parsedOtherMenuItems = JSON.parse(newValue);
    } catch (err) {
      console.warn('Invalid JSON for otherMenuItems', newValue);
      this.parsedOtherMenuItems = [];
    }
  }

  componentWillLoadS() {
    this.parseDropDownMenuItems(this.otherMenuItems);
  }
  parseDropDownMenuItems(newValue: string) {
    try {
      this.parsedDropDownMenuItems = JSON.parse(newValue);
    } catch (err) {
      console.warn('Invalid JSON for otherMenuItems', newValue);
      this.parsedDropDownMenuItems = [];
    }
  }

  get parsedLoginPopupItems() {
    if (typeof this.loginPopupLinks === 'string') {
      try {
        return JSON.parse(this.loginPopupLinks);
      } catch {
        console.warn('Invalid JSON in loginPopupLinks');
        return [];
      }
    }
  }

  toggleSidebarSubMenu(index: string) {
    if (index === '') {
      this.openMenus = {};
      return;
    }

    const isCurrentlyOpen = this.openMenus[index];
    const newOpenMenus = {};

    if (!isCurrentlyOpen) {
      const parts = index.split('-');
      let parentPath = '';

      for (let i = 0; i < parts.length - 1; i++) {
        parentPath = parentPath ? `${parentPath}-${parts[i]}` : parts[i];
        newOpenMenus[parentPath] = true;
      }

      newOpenMenus[index] = true;
    } else {
      for (const key in this.openMenus) {
        if (key !== index && !key.startsWith(`${index}-`)) {
          newOpenMenus[key] = true;
        }
      }
    }

    this.openMenus = newOpenMenus;
  }

  toggleEscapeKey = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.isMenuOpen = false;
      this.isAccessibiltyOpen = false;
      this.isMobileAccessibiltyOpen = false;
      this.isSubMenuOpen = false;
      this.isSideSubMenuOpen = false;
      this.isDesktopLoginPopupOpen = false;
      this.isMobileLoginPopupOpen = false;
    }
  };

  componentDidLoad() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.toggleEscapeKey);
    document.addEventListener('click', this.handleOutsideAccessibilityClick);
    document.addEventListener('click', this.handleOutsideLoginPopupClick);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('click', this.handleOutsideAccessibilityClick);
    document.removeEventListener('click', this.handleOutsideLoginPopupClick);
  }

  handleOutsideClick = (event: MouseEvent) => {
    let isClickInsideMenu = (event.target as Element).closest('.main_side_menu');
    if (!isClickInsideMenu) {
      this.toggleSidebarSubMenu('');
      document.querySelectorAll('.main_sub_menu').forEach(menu => {
        menu.classList.remove('showSubMenu');
      });
      document.querySelectorAll('.showSub').forEach(anchor => {
        anchor.classList.remove('icon_arrow');
      });
    }
  };

  handleOutsideAccessibilityClick = (event: MouseEvent) => {
    if (this.isAccessibiltyOpen) {
      const accessibilityMenu = document.querySelector('.dda-accessibility-wrap .dda-accessibility');
      const isClickInsideDesktopMenu = accessibilityMenu && accessibilityMenu.contains(event.target as Node);
      const isClickOnToggleButton = (event.target as Element).closest('.accessibility-btn');

      if (!isClickInsideDesktopMenu && !isClickOnToggleButton) {
        this.isAccessibiltyOpen = false;
      }
    }
  };

  handleOutsideLoginPopupClick = (event: MouseEvent) => {
    if (this.isDesktopLoginPopupOpen || this.isMobileLoginPopupOpen) {
      const loginPopup = document.querySelector('.dda-login-popup');
      const isClickInsideDesktopMenu = loginPopup && loginPopup.contains(event.target as Node);
      const isClickOnToggleButton = (event.target as Element).closest('.login-button');

      if (!isClickInsideDesktopMenu && !isClickOnToggleButton) {
        this.isDesktopLoginPopupOpen = false;
        this.isMobileLoginPopupOpen = false;
      }
    }
  };

  handleScroll = () => {
    const scrollTop = window.scrollY;
    const menuContainer = document.querySelector('.dda-menu-container') as HTMLElement;
    const logoContainer = document.querySelector('.dda-header') as HTMLElement;

    if (scrollTop > this.lastScrollTop && scrollTop > 50) {
      if (menuContainer) menuContainer.style.display = 'none';
      if (logoContainer) logoContainer.classList.add('white');
    } else {
      if (menuContainer) menuContainer.style.display = 'flex';
      if (logoContainer) logoContainer.classList.remove('white');
    }
    this.lastScrollTop = scrollTop;
  };

  private parseJsonArray(jsonString: string) {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      console.error('Failed to parse JSON:', e);
      return [];
    }
  }
  private toggleMenu = () => {
    if (this.isAccessibiltyOpen) {
      this.isAccessibiltyOpen = false;
    }

    if (this.isDesktopLoginPopupOpen || this.isMobileLoginPopupOpen) {
      this.isDesktopLoginPopupOpen = false;
      this.isMobileLoginPopupOpen = false;
    }
    this.isMenuOpen = !this.isMenuOpen;

    if (this.isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  private toggleAccessibilty = () => {
    if (this.usePredesignedAccessibilityMenu == true) {
      this.isAccessibiltyOpen = !this.isAccessibiltyOpen;
      this.accessibilitymenuhandler();
    } else {
      this.accessibilitymenuhandler();
    }
  };

  private toggleMobileAccessibilty = () => {
    if (this.usePredesignedAccessibilityMenu == true) {
      this.isMobileAccessibiltyOpen = !this.isMobileAccessibiltyOpen;
      this.MobileAccessibilitymenuhandler();
    } else {
      this.MobileAccessibilitymenuhandler();
    }
  };

  private languagehandler = () => {
    this.languageSwitch.emit();
  };
  private smTexthandler = () => {
    this.selected_text_size = 'small';
    this.smTextSize.emit();
  };
  private baseTexthandler = () => {
    this.selected_text_size = 'normal';
    this.baseTextSize.emit();
  };
  private lgTexthandler = () => {
    this.selected_text_size = 'large';
    this.lgTextSize.emit();
  };

  private normalContrasthandler = () => {
    this.selected_contrast = 'normal';
    this.normalContrast.emit();
  };
  private blindContrasthandler = () => {
    this.selected_contrast = 'colorblind';
    this.blindContrast.emit();
  };
  private redContrasthandler = () => {
    this.selected_contrast = 'redweakness';
    this.redContrast.emit();
  };
  private greenContrasthandler = () => {
    this.selected_contrast = 'greenweakness';
    this.greenContrast.emit();
  };

  private accessibilitymenuhandler = () => {
    this.accessibilitymenufunctionality.emit();
  };
  private MobileAccessibilitymenuhandler = () => {
    this.accessibilitymenufunctionality.emit();
  };

  private searchhandler = searchval => {
    this.searchfunctionality.emit(searchval);
  };

  private toggleLogin = () => {
    if (this.useLoginPopup == true) {
      this.loginClick.emit();
      if (window.innerWidth >= 768) {
        this.isDesktopLoginPopupOpen = !this.isDesktopLoginPopupOpen;
      } else {
        this.isMobileLoginPopupOpen = !this.isMobileLoginPopupOpen;
      }
    }
  };

  private handleMenuClick(e: Event, item: any, currentIndex: string) {
    if (item.subMenu && item.subMenu.length > 0) {
      e.preventDefault();
      const anchor = e.currentTarget as HTMLElement;
      // Toggle submenu
      this.toggleSidebarSubMenu(currentIndex);
      // Toggle .icon_arrow on the clicked <a>
      if (anchor.classList.contains('icon_arrow')) {
        anchor.classList.remove('icon_arrow');
      } else {
        anchor.classList.add('icon_arrow');
      }
      // Optional: If you want to close all submenus at the same level
      const siblingAnchors = anchor.closest('ol')?.querySelectorAll('a.icon_arrow');
      siblingAnchors?.forEach(el => {
        if (el !== anchor) {
          el.classList.remove('icon_arrow');
        }
      });
    } else {
      console.log('check navigator', this.useNavigator, this.navigatorClick);

      if (this.useNavigator == 'true') {
        this.navigatorClick.emit(item.href);
      }
    }
  }

  renderSubMenu = (subMenu, parentLi) => {
    if (!subMenu || subMenu.length === 0) return null;
    return (
      <div class={`main_sub_menu ${this.openMenus[parentLi] ? 'showSubMenu' : ''}`}>
        {subMenu[0].headerLabel && <h6 class="dda-side-nav__title">{subMenu[0].headerLabel}</h6>}
        <ol>
          {subMenu.map((item, index) => {
            const currentIndex = `${parentLi}-${index}`;
            return (
              <li key={currentIndex}>
                <a
                  href={this.useNavigator == 'true' ? 'javascript:void(0)' : item.href}
                  class={`${item.subLinkClass} ${item.subMenu && item.subMenu.length > 0 ? 'showSub' : ''}`}
                  onClick={e => {
                    this.handleMenuClick(e, item, currentIndex);
                  }}
                >
                  {item.label}
                </a>
                {this.renderSubMenu(item.subMenu, currentIndex)}
              </li>
            );
          })}
        </ol>
      </div>
    );
  };

  renderLoginPopup = () => {
    return (
      <ul>
        {this.parsedLoginPopupItems.map((item, index) => {
          return (
            <li key={`top-${index}`}>
              <a
                href={this.useNavigator == 'true' ? 'javascript:void(0)' : item.url}
                class=""
                onClick={() => {
                  if (this.useNavigator == 'true') {
                    this.navigatorClick.emit(item.url);
                  }
                  this.isDesktopLoginPopupOpen = false;
                }}
              >
                {item.popupItemLabel}
              </a>
            </li>
          );
        })}
      </ul>
    );
  };

  render() {
    const sideMenuItems = this.parseJsonArray(this.sideMenuItems);

    return (
      <header class={'dda-header'}>
        {/* Logo Section */}
        <div class="dda-head-logo">
          <a
            href={this.useNavigator == 'true' ? 'javascript:void(0)' : this.firstLogoHref}
            onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(this.firstLogoHref) : '')}
            class="govt-logo"
          >
            <img class="logo-white" src={this.firstLogoWhiteSrc} alt={`${this.firstLogoAlt} White`} />
            <img class="logo-colored" src={this.firstLogoSrc} alt={this.firstLogoAlt} />
          </a>
          <a
            href={this.useNavigator == 'true' ? 'javascript:void(0)' : this.secondLogoHref}
            onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(this.secondLogoHref) : '')}
            class="entt-logo"
          >
            <img class="logo-white" src={this.secondLogoWhiteSrc} alt={`${this.secondLogoAlt} White`} />
            <img class="logo-colored" src={this.secondLogoSrc} alt={this.secondLogoAlt} />
          </a>
        </div>

        {/* Main Navigation Section */}
        <div class="dda-menu-container">
          <div class="dda-main-navigation">
            <div class={`dda-menu-overley ${this.isMenuOpen ? 'show-overley' : ''}`} onClick={this.toggleMenu}></div>

            {/* Hamburger Menu */}
            <div class="hamburger-menu" onClick={this.toggleMenu}>
              <dda-tooltip title_text={this.hamburger_menu_button_name} position="top" class="dda-d-block">
                <button type="button" class="hamburger-menu-btn" name={this.hamburger_menu_button_name}>
                  <span class="hamburger-line"></span>
                  <span class="hamburger-menu-text">{this.hamburger_menu_button_name}</span>
                </button>
              </dda-tooltip>
            </div>

            {/* Side Menu */}
            <div class="dda-sidemenu" style={{ display: this.isMenuOpen ? 'block' : '', insetInlineStart: this.isMenuOpen ? '0px' : '' }}>
              <div class="dda-sidemenu-content">
                <h6 class="dda-side-nav-title">{this.sideMainMenuTitle}</h6>

                <ul class="main_side_menu">
                  {sideMenuItems.map((menu, index) => {
                    const currentIndex = `menu-${index}`;
                    return (
                      <li key={currentIndex} id={`header_${menu.label}`}>
                        <a
                          // href={menu.href}
                          href={this.useNavigator == 'true' ? 'javascript:void(0)' : menu.href}
                          class={menu.subMenu && menu.subMenu.length > 0 ? 'showSub' : ''}
                          onClick={e => {
                            if (menu.subMenu && menu.subMenu.length > 0) {
                              e.preventDefault();
                              const current = e.currentTarget as HTMLElement;
                              if (current.classList.contains('icon_arrow')) {
                                // If already active, remove it (toggle off)
                                current.classList.remove('icon_arrow');
                                this.toggleSidebarSubMenu(currentIndex); // Optionally collapse submenu
                                return;
                              }
                              // Remove .icon_arrow from ALL other anchors
                              const allAnchors = document.querySelectorAll('.main_side_menu a.icon_arrow');
                              allAnchors.forEach(anchor => anchor.classList.remove('icon_arrow'));
                              // Add .icon_arrow to the clicked anchor
                              current.classList.add('icon_arrow');
                              // Show submenu
                              this.toggleSidebarSubMenu(currentIndex);
                            } else {
                              if (this.useNavigator == 'true') {
                                this.navigatorClick.emit(menu.href);
                              }
                            }
                          }}
                        >
                          {menu.label}
                        </a>

                        {this.renderSubMenu(menu.subMenu, currentIndex)}
                      </li>
                    );
                  })}
                </ul>

                {this.hideOtherMenu == false && <h6 class="dda-side-nav-title">{this.sideOtherMenuTitle}</h6>}

                {!this.hideOtherMenu && (
                  <ul class="main_side_menu">
                    {this.parsedOtherMenuItems.map((itemlist, index) => (
                      <li key={`other-${index}`}>
                        <a
                          href={this.useNavigator == 'true' ? 'javascript:void(0)' : itemlist.href}
                          onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(itemlist.href) : '')}
                        >
                          {itemlist.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div class="dda-sidemenu-bottom">
                <div class="dda-sidemenu-gov-logo">
                  <a
                    href={this.useNavigator == 'true' ? 'javascript:void(0)' : this.firstLogoHref}
                    onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(this.firstLogoHref) : '')}
                    class="govt-logo dda-mb-2"
                  >
                    <img class="" src={this.firstLogoSrc} alt={this.firstLogoAlt} />
                  </a>
                </div>
                <div class="dda-toolbar-menu-sidemenu">
                  <ul>
                    {/* Mobile Accessibility Button */}
                    {this.accessibility_button_id && (
                      <li>
                        <button
                          name={this.toggle_accessibility_button_name}
                          class="tool-btn accessibility-btn"
                          type="button"
                          onClick={this.toggleMobileAccessibilty}
                          id={this.accessibility_button_id}
                        >
                          <i class={this.accessibility_button_icon_family}>{this.accessibility_button_icon_name}</i>
                          <span class="visually-hidden">{this.accessibility_button_text}</span>
                        </button>
                      </li>
                    )}

                    {this.language_text && (
                      <li>
                        <button name={this.language_button_name} class="tool-btn" type="button" onClick={this.languagehandler}>
                          {this.language_text}
                        </button>
                      </li>
                    )}

                    {this.loginText && (
                      <li>
                        <dda-link-button
                          button_color="onsurface-secondary"
                          start_icon={this.loginIcon}
                          custom_class="tool-btn login-button"
                          link_button_text={this.loginText}
                          onClick={this.toggleLogin}
                          // href={this.loginLink}
                          href={this.useLoginPopup ? 'javascript:void(0)' : this.loginLink}
                          button_shape="circle"
                          size="sm"
                        ></dda-link-button>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              <button type="button" name={this.close_menu_button_name} class="close-btn side-nav-close-btn" aria-label="Close Sidebar" onClick={this.toggleMenu}>
                <i class="material-icons  material-symbols-outlined" aria-hidden="true">
                  close
                </i>
              </button>

              {/* Mobile Accessibility Popup */}
              {this.usePredesignedAccessibilityMenu ? (
                <div class="dda-accessibility hide-accessibility mobile-accessibility" style={{ display: this.isMobileAccessibiltyOpen ? 'block' : 'none' }}>
                  <div class="mobile-accessibility-content">
                    <div class="dda-row">
                      <div class="dda-col-md-4 dda-accessibility-item">
                        <h6 class="h6 Regular dda-mb-1">{this.contrast_title}</h6>

                        <form>
                          <fieldset class="dda-theme-list">
                            <legend>
                              <p class="body Regular dda-mb-3">{this.contrast_description}</p>
                            </legend>
                            {this.contrast_noraml_text ? (
                              <dda-radiobutton
                                title_text={this.contrast_noraml_text}
                                checked={this.selected_contrast == 'normal'}
                                size="default"
                                variants="normal"
                                supporting=""
                                error_message=""
                                validation_id="NormalThemeMobile"
                                group_name="themeselectionMobile"
                                input_id="NormalThemeMobile"
                                custom_class=""
                                component_mode=""
                                aria_label="radio-button"
                                validation_type="normal"
                                onChange={this.normalContrasthandler}
                                class="hydrated"
                              ></dda-radiobutton>
                            ) : null}

                            {this.contrast_color_blind_text ? (
                              <dda-radiobutton
                                title_text={this.contrast_color_blind_text}
                                checked={this.selected_contrast == 'colorblind'}
                                size="default"
                                variants="normal"
                                supporting=""
                                error_message=""
                                validation_id="ColoursBlindMobile"
                                group_name="themeselectionMobile"
                                input_id="ColoursBlindMobile"
                                custom_class=""
                                component_mode=""
                                aria_label="radio-button"
                                validation_type="normal"
                                onChange={this.blindContrasthandler}
                                class="hydrated"
                              ></dda-radiobutton>
                            ) : null}

                            {this.contrast_red_weakness_text ? (
                              <dda-radiobutton
                                title_text={this.contrast_red_weakness_text}
                                checked={this.selected_contrast == 'redweakness'}
                                size="default"
                                variants="normal"
                                supporting=""
                                error_message=""
                                validation_id="RedWeaknessMobile"
                                group_name="themeselectionMobile"
                                input_id="RedWeaknessMobile"
                                custom_class=""
                                component_mode=""
                                aria_label="radio-button"
                                validation_type="normal"
                                onChange={this.redContrasthandler}
                                class="hydrated"
                              ></dda-radiobutton>
                            ) : null}

                            {this.contrast_green_weakness_text ? (
                              <dda-radiobutton
                                title_text={this.contrast_green_weakness_text}
                                checked={this.selected_contrast == 'greenweakness'}
                                size="default"
                                variants="normal"
                                supporting=""
                                error_message=""
                                validation_id="GreenWeaknessMobile"
                                group_name="themeselectionMobile"
                                input_id="GreenWeaknessMobile"
                                custom_class=""
                                component_mode=""
                                aria_label="radio-button"
                                validation_type="normal"
                                onChange={this.greenContrasthandler}
                                class="hydrated"
                              ></dda-radiobutton>
                            ) : null}
                          </fieldset>
                        </form>
                      </div>
                      <div class="dda-col-md-4 dda-accessibility-item">
                        <h6 class="h6 Regular dda-mb-1">{this.screen_reader_title}</h6>
                        <p class="body Regular dda-mb-3">{this.screen_reader_description}</p>
                        <div class="rs_skip rsbtn rs_preserve rs_mobile" id="readspeaker_button1">
                          <a
                            rel="nofollow"
                            href={this.read_speaker_link}
                            role="button"
                            class="rsbtn_play circle readspeaker"
                            accessKey="L"
                            aria-label="Listen to this page using ReadSpeaker"
                            data-rsshortcut="play"
                            aria-haspopup="menu"
                            data-rs-lang="en_uk"
                          >
                            <i class="material-icons  material-symbols-outlined" aria-hidden="true">
                              volume_up
                            </i>
                          </a>
                        </div>
                      </div>
                      <div class="dda-col-md-4 dda-accessibility-item">
                        <h6 class="h6 Regular dda-mb-1">{this.text_size_title}</h6>
                        <p class="body Regular dda-mb-3">{this.text_size_description}</p>
                        <div class="dda-d-flex dda-gap-4">
                          <dda-button
                            button_color={this.selected_text_size == 'normal' ? 'default-primary' : 'default-secondary'}
                            button_text="A"
                            icon_button_shape="circle"
                            custom_class=""
                            size="lg"
                            onClick={this.baseTexthandler}
                          ></dda-button>
                          <dda-button
                            button_color={this.selected_text_size == 'large' ? 'default-primary' : 'default-secondary'}
                            button_text="A+"
                            icon_button_shape="circle"
                            custom_class=""
                            size="lg"
                            onClick={this.lgTexthandler}
                          ></dda-button>

                          <dda-button
                            button_color={this.selected_text_size == 'small' ? 'default-primary' : 'default-secondary'}
                            button_text="A-"
                            icon_button_shape="circle"
                            custom_class=""
                            size="lg"
                            onClick={this.smTexthandler}
                          ></dda-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    name={this.close_accessibility_button_name}
                    class="close-btn close_accessibility"
                    aria-label="Close Accessibility"
                    onClick={this.toggleMobileAccessibilty}
                  >
                    <i class="material-icons  material-symbols-outlined" aria-hidden="true">
                      close
                    </i>
                  </button>
                </div>
              ) : null}
            </div>

            {/* headermenu */}
            {this.quickLinks && (
              <dda-header-menu
                use-navigator={this.useNavigator}
                navigator-click={this.navigatorClick}
                show-Quick-Links-Icon={this.showQuickLinksIcon}
                quick-links={typeof this.quickLinks === 'string' ? this.quickLinks : JSON.stringify(this.quickLinks)}
              ></dda-header-menu>
            )}
          </div>

          <div class="dda-mobile-entt-logo">
            <a
              href={this.useNavigator == 'true' ? 'javascript:void(0)' : this.secondLogoHref}
              onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(this.secondLogoHref) : '')}
              class="entt-logo"
            >
              <img class="logo-colored" src={this.secondLogoSrc} alt={this.secondLogoAlt} />
              <img class="logo-white" src={this.secondLogoWhiteSrc} alt={this.secondLogoAlt} />
            </a>
          </div>
          <div class="dda-mobile-search">
            {this.mobileMenuSearchId && (
              <a
                href={this.useNavigator == 'true' ? 'javascript:void(0)' : this.mobileMenuSearchUrl}
                onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(this.mobileMenuSearchUrl) : '')}
                class="tool-btn"
                id={this.mobileMenuSearchId}
              >
                <span class="visualy-hidden">{this.searchText || 'Search'}</span>
                <i class="material-icons  material-symbols-outlined" aria-hidden="true">
                  search
                </i>
              </a>
            )}
          </div>

          {/* Toolbar Menu */}
          <div class="dda-toolbar-menu">
            <ul>
              {this.search_input_name && (
                <li>
                  <dda-tooltip title_text={this.search_tooltip || 'Search'} description="" position="top">
                    <div class="dda-search dda-header-search">
                      <label id="ddaSearch-label" class="visualy-hidden" aria-hidden="true">
                        {this.searchText || 'Search'}
                      </label>
                      <i class="material-icons  material-symbols-outlined" aria-hidden="true">
                        search
                      </i>
                      <dda-input
                        placeholder={this.search_input_placeholder || 'Search'}
                        type="text"
                        input_id="ddaSearch"
                        value={this.search_value}
                        input_name={this.search_input_name}
                        aria_label="input"
                        input_role="search"
                        error_message="Error text"
                        validation_type="normal"
                        validation_id="validationId"
                        input_status="normal"
                        size="default"
                        custom_class="dda-header-search-input tool-btn"
                        component_mode=""
                        // handleInput={(event) => console.log(event.target.value,"")}
                        onKeyPress={e => {
                          if (e.key === 'Enter') {
                            this.searchhandler((e.target as HTMLInputElement).value); // Pass the value to the searchhandler
                          }
                        }}
                      ></dda-input>
                      <span id="validationId" class="visually-hidden">
                        Enter keywords to search the site.
                      </span>
                    </div>
                  </dda-tooltip>
                </li>
              )}

              {this.accessibility_button_id && (
                <li>
                  <dda-tooltip title_text={this.accessibility_tooltip} position="top">
                    <button
                      name={this.toggle_accessibility_button_name}
                      class="tool-btn dda-btn btn-color-onsurface-secondary btn-size-sm btn-shape-circle accessibility-btn"
                      type="button"
                      onClick={this.toggleAccessibilty}
                      id={this.accessibility_button_id}
                    >
                      <i class={this.accessibility_button_icon_family}>{this.accessibility_button_icon_name}</i>
                      <span class="visually-hidden">{this.accessibility_button_text}</span>
                    </button>
                  </dda-tooltip>
                  {this.usePredesignedAccessibilityMenu ? (
                    <div class="dda-accessibility-wrap">
                      <div class="dda-accessibility hide-accessibility" style={{ display: this.isAccessibiltyOpen ? 'block' : 'none' }}>
                        <div class="dda-row">
                          <div class="dda-col-md-4 dda-accessibility-item">
                            <h6 class="h6 Regular dda-mb-1">{this.contrast_title}</h6>
                            <form>
                              <fieldset class="dda-theme-list">
                                <legend>
                                  <p class="body Regular dda-mb-3">{this.contrast_description}</p>
                                </legend>

                                {this.contrast_noraml_text ? (
                                  <dda-radiobutton
                                    title_text={this.contrast_noraml_text}
                                    checked={this.selected_contrast == 'normal'}
                                    size="default"
                                    variants="normal"
                                    supporting=""
                                    error_message=""
                                    validation_id="NormalTheme"
                                    group_name="themeselection"
                                    input_id="NormalTheme"
                                    custom_class=""
                                    component_mode=""
                                    aria_label="radio-button"
                                    validation_type="normal"
                                    onChange={this.normalContrasthandler}
                                    class=""
                                  ></dda-radiobutton>
                                ) : null}

                                {this.contrast_color_blind_text ? (
                                  <dda-radiobutton
                                    title_text={this.contrast_color_blind_text}
                                    checked={this.selected_contrast == 'colorblind'}
                                    size="default"
                                    variants="normal"
                                    supporting=""
                                    error_message=""
                                    validation_id="ColoursBlind"
                                    group_name="themeselection"
                                    input_id="ColoursBlind"
                                    custom_class=""
                                    component_mode=""
                                    aria_label="radio-button"
                                    validation_type="normal"
                                    onChange={this.blindContrasthandler}
                                    class="hydrated"
                                  ></dda-radiobutton>
                                ) : null}

                                {this.contrast_red_weakness_text ? (
                                  <dda-radiobutton
                                    title_text={this.contrast_red_weakness_text}
                                    checked={this.selected_contrast == 'redweakness'}
                                    size="default"
                                    variants="normal"
                                    supporting=""
                                    error_message=""
                                    validation_id="RedWeakness"
                                    group_name="themeselection"
                                    input_id="RedWeakness"
                                    custom_class=""
                                    component_mode=""
                                    aria_label="radio-button"
                                    validation_type="normal"
                                    onChange={this.redContrasthandler}
                                    class="hydrated"
                                  ></dda-radiobutton>
                                ) : null}

                                {this.contrast_green_weakness_text ? (
                                  <dda-radiobutton
                                    title_text={this.contrast_green_weakness_text}
                                    checked={this.selected_contrast == 'greenweakness'}
                                    size="default"
                                    variants="normal"
                                    supporting=""
                                    error_message=""
                                    validation_id="GreenWeakness"
                                    group_name="themeselection"
                                    input_id="GreenWeakness"
                                    custom_class=""
                                    component_mode=""
                                    aria_label="radio-button"
                                    validation_type="normal"
                                    onChange={this.greenContrasthandler}
                                    class="hydrated"
                                  ></dda-radiobutton>
                                ) : null}
                              </fieldset>
                            </form>
                          </div>
                          <div class="dda-col-md-4 dda-accessibility-item">
                            <h6 class="h6 Regular dda-mb-1">{this.screen_reader_title}</h6>
                            <p class="body Regular dda-mb-3">{this.screen_reader_description}</p>
                            <div class="rs_skip rsbtn rs_preserve rs_mobile" id="readspeaker_button1">
                              <a
                                rel="nofollow"
                                href={this.read_speaker_link}
                                role="button"
                                class="rsbtn_play circle readspeaker"
                                accessKey="L"
                                aria-label="Listen to this page using ReadSpeaker"
                                data-rsshortcut="play"
                                aria-haspopup="menu"
                                data-rs-lang="en_uk"
                              >
                                <i class="material-icons  material-symbols-outlined" aria-hidden="true">
                                  volume_up
                                </i>
                              </a>
                            </div>
                          </div>
                          <div class="dda-col-md-4 dda-accessibility-item">
                            <h6 class="h6 Regular dda-mb-1">{this.text_size_title}</h6>
                            <p class="body Regular dda-mb-3">{this.text_size_description}</p>
                            <div class="dda-d-flex dda-gap-4">
                              <dda-button
                                button_color={this.selected_text_size == 'normal' ? 'default-primary' : 'default-secondary'}
                                button_text="A"
                                icon_button_shape="circle"
                                custom_class=""
                                size="lg"
                                onClick={this.baseTexthandler}
                              ></dda-button>
                              <dda-button
                                button_color={this.selected_text_size == 'large' ? 'default-primary' : 'default-secondary'}
                                button_text="A+"
                                icon_button_shape="circle"
                                custom_class=""
                                size="lg"
                                onClick={this.lgTexthandler}
                              ></dda-button>
                              <dda-button
                                button_color={this.selected_text_size == 'small' ? 'default-primary' : 'default-secondary'}
                                button_text="A-"
                                icon_button_shape="circle"
                                custom_class=""
                                size="lg"
                                onClick={this.smTexthandler}
                              ></dda-button>
                            </div>
                          </div>
                        </div>

                        <button
                          type="button"
                          name={this.close_accessibility_button_name}
                          class="close-btn close_accessibility"
                          aria-label="Close Sidebar"
                          onClick={this.toggleAccessibilty}
                        >
                          <i class="material-icons  material-symbols-outlined" aria-hidden="true">
                            close
                          </i>
                        </button>
                      </div>
                    </div>
                  ) : null}
                </li>
              )}

              {this.language_text && (
                <li>
                  <dda-tooltip title_text={this.language_tooltip} position="top">
                    <dda-button
                      button_color="onsurface-secondary"
                      custom_class="tool-btn"
                      button_text={this.language_text}
                      button_shape="circle"
                      size="sm"
                      onClick={this.languagehandler}
                    ></dda-button>
                  </dda-tooltip>
                </li>
              )}

              {this.loginText && (
                <li>
                  <dda-tooltip title_text={this.login_tooltip} position="top">
                    <dda-link-button
                      button_color="onsurface-secondary"
                      start_icon={this.loginIcon}
                      custom_class="tool-btn login-button"
                      link_button_text={this.loginText}
                      onClick={this.toggleLogin}
                      // href={this.loginLink}
                      href={this.useLoginPopup ? 'javascript:void(0)' : this.loginLink}
                      button_shape="circle"
                      size="sm"
                    ></dda-link-button>
                  </dda-tooltip>
                </li>
              )}
            </ul>
          </div>

          {this.useLoginPopup ? (
            <div class="dda-login-popup desktop" style={{ display: this.isDesktopLoginPopupOpen ? 'block' : 'none' }}>
              {this.renderLoginPopup()}
            </div>
          ) : null}

          {this.useLoginPopup ? (
            <div class="dda-login-popup mobile" style={{ display: this.isMobileLoginPopupOpen ? 'block' : 'none' }}>
              {this.renderLoginPopup()}
            </div>
          ) : null}
        </div>
      </header>
    );
  }
}
